import classnames from 'classnames';
import { FC, ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

type TextFieldProps = FieldRenderProps<string, HTMLElement, string> & {
  labelText?: string;
  multiline?: boolean;
  icon?: ReactNode;
  className?: string;
};

const TextField: FC<TextFieldProps> = ({
  input,
  labelText,
  meta: { touched, error },
  multiline = false,
  icon,
  className,
  ...otherProps
}) => {
  const containerClassName = classnames('relative block w-full');
  const defaultInputClassName =
    'block w-full rounded-md border-gray-300 text-sm shadow-sm';

  // Add padding for the icon only if an icon is present
  const iconPadding = icon ? 'pl-10' : '';

  const inputClassName = classnames(
    className || `${defaultInputClassName} ${iconPadding}`,
    {
      'border-red-800': touched && error,
    },
  );

  return (
    <>
      <label
        htmlFor={input.name}
        className={classnames('text-sm text-primaryGray', {
          'sr-only': !labelText,
        })}
      >
        {labelText || input.name}
      </label>
      <div className={containerClassName}>
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
            {icon}
          </span>
        )}
        {multiline ? (
          <textarea
            id={input.name}
            className={inputClassName}
            {...input}
            {...otherProps}
          />
        ) : (
          <input
            id={input.name}
            type="text"
            className={inputClassName}
            autoComplete="off"
            {...input}
            {...otherProps}
          />
        )}
      </div>
      {touched && error && (
        <span className="text-xs text-red-800">{error}</span>
      )}
    </>
  );
};

export default TextField;
